// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"styles_descriptionContainer__QZ6dB","descriptionCard":"styles_descriptionCard__LV0ui"};